import * as React from 'react';
import linkageIcon from '../../../assets/linkage.svg';
import { IconProps } from '../../typescriptHelpers';

interface LinkageIconProps extends IconProps {
    style?: React.CSSProperties;
}

const LinkageIcon: React.FC<LinkageIconProps> = ({ width, height, style }: LinkageIconProps) => {
    return <img src={linkageIcon} width={width} height={height} style={style ? { ...style } : {}} />;
};

export default LinkageIcon;
